module.exports = __webpack_public_path__ + "img/Ann-LogoContact.22975d7b.jpg";